import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PersonaContext } from "../context/PersonaContext";
import Header from "../components/Header";
import StatusBar from "../components/StatusBar";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorMessage from "../components/ErrorMessage";
import { getDatasets, retryApiCall } from "../services/api";
import HelpTooltip from "../components/HelpTooltip";

const DatasetPage = () => {
  const {
    selectedDataset,
    setSelectedDataset,
    selectedSectors,
    selectedLocation,
  } = useContext(PersonaContext);
  const { setSelectedDatasetPath, setSelectedDatasetName } =
    useContext(PersonaContext);
  const [datasets, setDatasets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [validationError, setValidationError] = useState("");

  const navigate = useNavigate();
  const { resetQuestions } = useContext(PersonaContext);

  const fetchDatasets = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await retryApiCall(getDatasets, [
        selectedSectors,
        selectedLocation,
      ]);
      if (Array.isArray(data)) {
        // Apply the filter to exclude dataset with id = 5 if location is 'Both'
        const filteredData =
          selectedLocation !== "Both"
            ? data.filter((dataset) => dataset.id !== 5)
            : data;
        setDatasets(filteredData);
      } else {
        setError("Unexpected response format");
      }
    } catch (error) {
      setError("Failed to load datasets");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDatasets();
  }, [selectedSectors, selectedLocation]);

  const handleNextClick = () => {
    if (!selectedDataset) {
      setValidationError("Please select a dataset");
      return;
    }
    navigate("/questions");
  };

  return (
    <div className="dataset-page">
      <Header />
      <StatusBar currentStep={2} />
      <h2>Select a Dataset</h2>
      <p>Please select a dataset to proceed.</p>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {error && (
            <div className="error-container">
              <ErrorMessage message={error} />
              <button onClick={fetchDatasets} className="retry-button">
                Try Again
              </button>
            </div>
          )}

          {validationError && <ErrorMessage message={validationError} />}
          <ul className="dataset-list">
            {Array.isArray(datasets) && datasets.length > 0 ? (
              datasets.map((dataset) => (
                <li key={dataset.id}>
                  <input
                    type="radio"
                    id={`dataset-${dataset.id}`}
                    name="dataset"
                    value={dataset.id}
                    checked={selectedDataset === dataset.id}
                    onChange={() => {
                      setValidationError("");
                      setSelectedDataset(dataset.id);
                      setSelectedDatasetPath(dataset.filepath);
                      setSelectedDatasetName(dataset.name);
                      resetQuestions();
                    }}
                    disabled={
                      dataset.id === 3 || dataset.id === 4 || dataset.id === 5
                    }
                  />

                  <label
                    htmlFor={`dataset-${dataset.id}`}
                    style={{
                      color:
                        dataset.id === 3 || dataset.id === 4 || dataset.id === 5
                          ? "gray"
                          : "inherit",
                    }}
                  >
                    {dataset.title}
                  </label>
                  <HelpTooltip
                    sections={[
                      { title: dataset.title, content: dataset.description },
                    ]}
                  />
                </li>
              ))
            ) : (
              <p>No datasets available.</p>
            )}
          </ul>
          <div className="navigation-buttons">
            <button
              onClick={() => navigate("/sectors")}
              className="back-button"
            >
              Back
            </button>
            <button onClick={handleNextClick} className="next-button">
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default DatasetPage;
